module.exports = __webpack_public_path__ + "static/img/about-this-report-hero-low.62da09a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/about-this-report-hero-low.jpg
// module id = RXEh
// module chunks = 0